// removed by extract-text-webpack-plugin
module.exports = {"placeholderGray":"#9297A3","selectBlue":"#ebf5ff","linkBlue":"#0076C0","borderGray":"#d9d9d9","backgroundGray":"#f6f7f8","runColor":"#0076C0","fitnessColor":"#375A92","xs":"undefined","sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","container":"container-2oPiw","thumbnailImage":"thumbnailImage-13LsF","thumbnail":"thumbnail-5DHBM","distance":"distance-fN70X","info":"info-V4x5k","name":"name-3nfmN","location":"location-21IGg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/RouteSelector/_routeItem.css
// module id = 1256
// module chunks = 1